import type { TaxListDetailReport } from 'model/TaxListReport';

export interface TaxListDetailReportState {
    loading: boolean;
    report: TaxListDetailReport;
}

export const emptyTaxListDetailReport = (): TaxListDetailReport => ({
    range: { start: '', end: '' },
    meta: {
        page: 1,
        perPage: 10,
        totalCount: 0,
        totalPages: 1
    },
    items: []
});

export const initialTaxListDetailReportState: TaxListDetailReportState = {
    loading: false,
    report: emptyTaxListDetailReport()
};
